const ContentModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    isEditing: false,
    idx: ''
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload
    },
    SET_IDX: (state, payload) => {
      state.idx = payload
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    INSERT: (state, payload) => {
      state.data.push(payload)
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/farmerspace/content/get`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit, dispatch }, payload) {
      try {
        const response = await axios.delete(
          `/farmerspace/content/delete/${payload}`
        )
        if (response.data.message === true) {
          iziToast.info({
            title: 'Deleted!',
            position: 'bottomRight'
          })
          location.reload()
        }
        // dispatch('fetch')
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(
          `/farmerspace/content/insert`,
          payload
        )
        if (response.data.message === true) {
          iziToast.success({
            title: 'Updated!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx == payload)
    }
  }
}

export default ContentModule



// WEBPACK FOOTER //
// ./src/store/modules/farmerspace/content.js